var map = {
	"./bookmark.svg": "463c",
	"./delete.svg": "d754",
	"./download.svg": "d35d",
	"./edit.svg": "b1b1",
	"./email.svg": "fa1c",
	"./error.svg": "1149",
	"./eye_white.svg": "c58f",
	"./image.svg": "ea7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21e6";